import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="channel-loader"
export default class extends Controller {
  static targets = ["select", "loadButton"]

  updateChannels(event) {
    const detail = event.detail
    if (detail[0]?.success && detail[0]?.channels) {
      const channels = detail[0].channels
      const selectElement = document.querySelector('#discord_setup_discord_default_channel_id')
      
      if (selectElement) {
        // Clear existing options
        selectElement.innerHTML = '<option value="">Sélectionnez un canal...</option>'
        
        // Add channel options
        channels.forEach(([name, id]) => {
          const option = document.createElement('option')
          option.value = id
          option.textContent = `# ${name}`
          selectElement.appendChild(option)
        })
        
        // Enable the select
        selectElement.disabled = false
        selectElement.classList.remove('bg-gray-100', 'text-gray-500')
        selectElement.classList.add('border-gray-300')
        
        this.showSuccess(`${channels.length} canaux chargés avec succès`)
      }
    } else {
      this.showError('Aucun canal trouvé ou erreur de chargement')
    }
  }

  showError(event) {
    const detail = event.detail
    const message = detail[0]?.message || 'Erreur lors du chargement des canaux'
    this.showNotification(message, 'error')
  }

  showSuccess(message) {
    this.showNotification(message, 'success')
  }

  showNotification(message, type) {
    // Create a temporary notification element
    const notification = document.createElement('div')
    notification.className = `fixed top-4 right-4 p-4 rounded-md shadow-lg z-50 ${
      type === 'success' ? 'bg-green-50 border border-green-200 text-green-700' : 'bg-red-50 border border-red-200 text-red-700'
    }`
    notification.innerHTML = `
      <div class="flex items-center space-x-2">
        <i class="fas fa-${type === 'success' ? 'check-circle' : 'exclamation-circle'}"></i>
        <span>${message}</span>
      </div>
    `
    
    document.body.appendChild(notification)
    
    // Remove after 3 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification)
      }
    }, 3000)
  }
}